/* Fleur — Testing & Quality modal: open/close, section + peptide navigation.
   Vanilla, dependency-free, event-delegated so it survives re-renders. */
(function () {
  var OPEN_CLASS = 'is-open';
  var BODY_CLASS = 'lab-modal-open';
  var lastFocused = null;

  function modal() { return document.getElementById('lab-modal'); }

  // Portal the modal to <body> so position:fixed can't be trapped by an
  // ancestor with a transform/filter (which would break the overlay).
  function portalModal() {
    var m = modal();
    if (m && m.parentNode !== document.body) document.body.appendChild(m);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', portalModal);
  } else {
    portalModal();
  }

  function openModal() {
    var m = modal();
    if (!m) return;
    lastFocused = document.activeElement;
    m.hidden = false;
    document.body.classList.add(BODY_CLASS);
    // next frame so the transition runs
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { m.classList.add(OPEN_CLASS); });
    });
    var closeBtn = m.querySelector('.lab-modal__close');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    var m = modal();
    if (!m || m.hidden) return;
    m.classList.remove(OPEN_CLASS);
    document.body.classList.remove(BODY_CLASS);
    var onEnd = function () {
      m.hidden = true;
      m.removeEventListener('transitionend', onEnd);
    };
    m.addEventListener('transitionend', onEnd);
    // fallback if transitionend doesn't fire
    setTimeout(function () { if (!m.classList.contains(OPEN_CLASS)) m.hidden = true; }, 350);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function selectSection(key) {
    var m = modal();
    if (!m) return;
    m.querySelectorAll('[data-lab-section]').forEach(function (tab) {
      var on = tab.getAttribute('data-lab-section') === key;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    m.querySelectorAll('[data-lab-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-lab-panel') !== key;
    });
    var body = m.querySelector('.lab-modal__body');
    if (body) body.scrollTop = 0;
  }

  function selectPeptide(key) {
    var m = modal();
    if (!m) return;
    m.querySelectorAll('[data-lab-peptide]').forEach(function (chip) {
      chip.classList.toggle('is-active', chip.getAttribute('data-lab-peptide') === key);
    });
    m.querySelectorAll('[data-lab-peptide-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-lab-peptide-panel') !== key;
    });
  }

  // Event delegation
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-lab-open]');
    if (opener) { e.preventDefault(); openModal(); return; }

    if (e.target.closest('[data-lab-close]')) { e.preventDefault(); closeModal(); return; }

    var sectionTab = e.target.closest('[data-lab-section]');
    if (sectionTab) { selectSection(sectionTab.getAttribute('data-lab-section')); return; }

    var peptideChip = e.target.closest('[data-lab-peptide]');
    if (peptideChip && !peptideChip.disabled) { selectPeptide(peptideChip.getAttribute('data-lab-peptide')); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
})();
